export const QUERY_SEND_NEWSLETTER = /* GraphQL */ `
	query (
		$attachments: [EmailAttachments!]
		$filter: ProfileFilter
		$html: String!
		$notFilter: ProfileFilter
		$subject: String!
	) {
		sendNewsletter(
			attachments: $attachments
			filter: $filter
			html: $html
			notFilter: $notFilter
			subject: $subject
		)
	}
`;
